"use client";
import React, { FC, useState } from "react";
import { ShowWhen } from "../show-when/show-when";
import { CloseModalIcon, InfoCircleIcon } from "@/components/assets/icons";
import { useTranslations } from "next-intl";

type Props = {
  text: string;
  showIcon?: boolean;
};

const WarningBox: FC<Props> = ({ text, showIcon }) => {
  const t = useTranslations();

  const [isOpened, setIsOpened] = useState(true);

  const handleClose = () => setIsOpened(false);

  return (
    <ShowWhen condition={isOpened}>
      <div className="mt-4 flex h-10 w-full items-center justify-start rounded-[20px] bg-[#f8f4c4] p-3">
        <ShowWhen condition={showIcon}>
          <InfoCircleIcon fill="#91722F" className="mr-[3px]" />
        </ShowWhen>
        <span className="text-xs font-normal text-[#91722f]">{t(text)}</span>
        <CloseModalIcon
          onClick={handleClose}
          className="ml-auto h-[18px] w-[18px] cursor-pointer fill-[#c3a86d]"
        />
      </div>
    </ShowWhen>
  );
};

export { WarningBox };
